import { all } from 'redux-saga/effects';
import login from './login';
import session from './session';
import user from './user';
import account from './account'
import establishmentsManagement from './establishments-management';
import usersManagement from './users-management';
import zwalletDashboard from '../ZWallet/Dashboard/sagas';
import zwalletOperations from '../ZWallet/Operations/sagas';
import zwalletTransfer from '../ZWallet/Transfer/sagas';
import zwalletPayment from '../ZWallet/Payment/sagas';

function* root() {
    yield all([
        account(),
        login(),
        session(),
        user(),
        establishmentsManagement(),
        usersManagement(),
        zwalletTransfer(),
        zwalletOperations(),
        zwalletDashboard(),
        zwalletPayment()
    ]);
}

export default root;



// WEBPACK FOOTER //
// ./src/sagas/index.js